module.exports = __webpack_public_path__ + "img/addSuccess.b80c7a45.png";